import { action, observable, computed } from "mobx"
import { Step, BookingFlow } from "../../BookingFlow"
import { WaiverEditor } from "./WaiverEditor"
import { BookingDB } from "../../db/BookingLightDB"

export class WaiversStep implements Step {
  @observable
  name = "Waivers"

  @observable
  flow: BookingFlow

  @observable
  instruction = "Add minors to your waiver, or sign for yourself."

  @observable
  help = "You must be the legal guardian to sign."

  @computed
  get waiverEditors() {
    return this.flow.currentBooking.waiversNeedingSigned.map(a => {
      return new WaiverEditor(this.db, this.flow, a[0], a[1])
    })
  }

  @observable
  db: BookingDB

  @action.bound
  addWaiver() {
    console.log("This button doesn't do anything")
  }
}
